import { LetterResDto } from '../dtos/letterResDTO';
import { atom } from 'recoil';

export const letterState = atom<LetterResDto | null>({
	key: 'letterState',
	default: null,
});
